<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-list">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Pegawai Import
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Pegawai Import</h5>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <h6>Template File Excel untuk Import Pegawai</h6>
        <img :src="imageUrl" alt="Example image" class="template-import" />
        <br />
        <p>
          Mohon menyesuaikan file excel import pegawai sesuai dengan kriteria
          berikut:
        </p>
        <ul>
          <li>
            Nama kolom yang diterima adalah: <mark>nama</mark>,<mark>nik</mark>,
            <mark>alamat</mark>,<mark>telp</mark>,<mark>tempat lahir</mark>,
            <mark>tanggal lahir</mark>,<mark>tanggal mulai bekerja</mark> dan
            <mark>agama</mark>,
          </li>
          <li><mark>nama</mark>: kolom <strong>harus diisi</strong></li>
          <li>
            <mark>nik</mark>: kolom
            <strong>harus diisi dan berupa angka</strong>
          </li>
          <li><mark>alamat</mark>: kolom tidak harus diisi</li>
          <li><mark>telp</mark>: kolom tidak harus diisi</li>
          <li><mark>tempat lahir</mark>: kolom <strong>harus diisi</strong></li>
          <li>
            <mark>tanggal lahir</mark>: kolom
            <strong
              >harus diisi dengan format bulan/tanggal/tahun
              (02/12/1995)</strong
            >
          </li>
          <li>
            <mark>tanggal mulai bekerja</mark>: kolom
            <strong
              >harus diisi dengan format bulan/tanggal/tahun
              (02/12/1995)</strong
            >
          </li>
          <li>
            <mark>agama</mark>: kolom
            <strong
              >harus diisi dengan nilai (Hindu, Islam, Protestan, Katolik,
              Buddha, Khonghucu)</strong
            >
          </li>
        </ul>
        <dl class="row">
          <dt class="col-sm-4">
            Download sample file excel untuk import data pegawai:
          </dt>
          <dt class="col-sm-8">
            <DxButton
              icon="download"
              text="Download"
              ref="fileDownloader"
              @click="downloadSample"
              styling-mode="outlined"
            />
          </dt>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">Import file excel data pegawai</dt>
          <dt class="col-sm-8">
            <input type="file" ref="fileInput" @change="handleFile" />
          </dt>
        </dl>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import DxButton from "devextreme-vue/button";
import notify from "devextreme/ui/notify";
import * as XLSX from "xlsx";
import { DateTime } from "luxon";
import _ from "lodash";
import axios from "axios";
export default {
  components: {
    DxButton,
  },
  data() {
    return {
      file: null,
      imageUrl: require("@/views/template_import_pegawai.png"),
      sampleUrl: "http://127.0.0.1/files/import_template_pegawai.xlsx",
    };
  },
  methods: {
    downloadSample() {
      window.open(this.sampleUrl, "_blank");
    },
    async handleFile(e) {
      // console.log("handle file");
      // console.log(DateTime.local());
      // console.log(DateTime.now().toString());

      // console.log(DateTime.now().toLocaleString(DateTime.DATETIME_MED));
      // console.log(DateTime.now().toFormat("HH 'hours and' mm 'minutes'"));
      // console.log(DateTime.now().toFormat("yyyy-LL-dd")); //convert ymd

      const files = e.target.files;
      const file = files[0];
      this.file = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: "binary",
          cellText: false,
          cellDates: true,
        });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        // this.data = XLSX.utils.sheet_to_json(worksheet);
        this.data = XLSX.utils.sheet_to_json(worksheet, {
          // header: 1,
          raw: false,
          dateNF: 'dd"/"mm"/"yyyy',
        });

        this.uploadAxios(prepareAxios(this.data));
      };

      reader.readAsBinaryString(file);
    },

    uploadAxios: function (data) {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      // let dataFin = JSON.stringify(data);

      axios
        .post("http://127.0.0.1/api/simpeg_pegawai_import", data, config)
        .then(function (res) {
          console.log(res);
          notify("Import data pegawai berhasil", "success");
        })
        .catch(function (err) {
          notify(
            "Import data pegawai gagal: " + err.response.data.message,
            "error"
          );
          console.log(err);
          // this.output = err;
        });
    },
  },
};

function dateValid(date) {
  console.log("==========datavelid=============");
  console.log(date);
  let tgl = DateTime.fromFormat(date, "dd/mm/yyyy");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  tgl = DateTime.fromFormat(date, "dd-mm-yyyy");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  tgl = DateTime.fromFormat(date, "YYYY-mm-dd");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  tgl = DateTime.fromFormat(date, "YYYY-mm-dd");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  tgl = DateTime.fromFormat(date, "YYYY-LL-dd");
  if (tgl.isValid) {
    return tgl.toFormat("yyyy-mm-dd");
  }
  return date;
}

function prepareID(source, key) {
  let find = _.find(source, { val: key });
  if (_.isUndefined(find)) return "";
  return find.id;
}

function prepareAxios(data) {
  const dataNew = [];
  var agamas = [
    { id: 1, val: "Hindu" },
    { id: 2, val: "Islam" },
    { id: 3, val: "Protestan" },
    { id: 4, val: "Katolik" },
    { id: 4, val: "Buddha" },
    { id: 4, val: "Khonghucu" },
  ];

  console.log("dataasli");
  console.log(data);
  _.forEach(data, (value) => {
    // value["tgl_lahir"] = dateValid(value["tgl_lahir"]);
    //perbaiki key/column db
    let newKey = _.mapKeys(value, (val, key) => {
      console.log(val);
      switch (_.toLower(key)) {
        case "agama":
          return "agama_id";
        case "tempat lahir":
          return "tempat_lahir";
        case "tgl lahir":
          return "tgl_lahir";
        case "tanggal lahir":
          return "tgl_lahir";
        case "tgl mulai bekerja":
          return "tgl_mulai_bekerja";
        case "tanggal mulai bekerja":
          return "tgl_mulai_bekerja";
        case "pegawai":
          return "nama";
        case "nama pegawai":
          return "nama";
        default:
          return _.toLower(_.replace(key, " ", "_"));
      }
    });

    newKey["agama_id"] = prepareID(agamas, newKey["agama_id"]);
    newKey["tgl_lahir"] = dateValid(newKey["tgl_lahir"]);
    newKey["tgl_mulai_bekerja"] = dateValid(newKey["tgl_mulai_bekerja"]);

    dataNew.push(newKey);
  });
  // console.log(data);
  console.log(dataNew);

  return dataNew;
}
</script>
<style>
.template-import {
  width: 1200px;
  height: auto;
  padding-bottom: 40px;
}
</style>
